import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectLog, injectQueryURL, TYPES as UTIL_TYPES } from '@monofe/util';
import { injectHistory } from '../history/interface';
import { TYPES as HISTORY_TYPES } from '../history/private';
import type { IRouter } from './interface';
import { bindRouter, injectRouter, unbindRouter } from './interface';
import { TYPES as ROUTER_TYPES } from './private';
import Router from './router';

function _build(container: IContainer): Promise<Readonly<IRouter>> {
    const query = injectQueryURL(container);
    const history = injectHistory(container);
    const log = injectLog(container);
    const router = Router(query, history, log);
    return Promise.resolve(Object.freeze(router));
}

export default buildBindable<IRouter>({
    id: ROUTER_TYPES.IRouter,
    dependencies: [UTIL_TYPES.IQueryURL, HISTORY_TYPES.IHistory, UTIL_TYPES.ILog],
    bind: bindRouter,
    remove: unbindRouter,
    inject: injectRouter,
    build: container => _build(container),
});
